const trendsNL = {
    "view": {
        "form": {
            "label": {
                "filters": "Filters",
                "period": "Periode",
                "store": "Winkel",
                "label": "Label",
                "release": "Release",
                "track": "Track",
                "subuser": "Subgebruiker",
                "fetchingTrends": "Trends ophalen uit database"
            },
            "button": {
                "resetFilters": "Filters Resetten"
            },
            "options": {
                "store": {
                    "allStores": "Alle Winkels",
                    "downloadStores": "Download Winkels",
                    "streamingStores": "Streaming Winkels",
                    "streamStores": "Stream Winkels"
                },
                "label": {
                    "allLabels": "Alle Labels"
                },
                "release": {
                    "allReleases": "Alle Releases"
                },
                "track": {
                    "allTracks": "Alle Tracks"
                },
                "subuser": {
                    "selectSubuser": "Selecteer Subgebruiker"
                },
                "period": {
                    "last7Days": "Laatste 7 Dagen",
                    "last14Days": "Laatste 14 Dagen",
                    "last30Days": "Laatste 30 Dagen",
                    "last45Days": "Laatste 45 Dagen",
                    "last60Days": "Laatste 60 Dagen",
                    "last75Days": "Laatste 75 Dagen",
                    "last90Days": "Laatste 90 Dagen"
                }
            }
        },
        "top10": {
            "title": "Top 10",
            "table": {
                "column": {
                    "artistName": "Artiest",
                    "songMixName": "Song/Mix Naam",
                    "numberOfSales": "Aantal Verkoop"
                }
            }
        },
        "storeWiseSales": {
            "title": "Winkel-specifieke Verkoop",
            "label": {
                "amazonMusicStream": "Amazon Music stream",
                "appleMusicStream": "Apple Music stream",
                "beatportStream": "Beatport stream",
                "deezerStream": "Deezer stream",
                "facebookStream": "Facebook stream",
                "instagramStream": "Instagram stream",
                "itunesDownload": "iTunes download",
                "pandoraStream": "Pandora stream",
                "soundcloudStream": "SoundCloud stream",
                "spotifyStream": "Spotify stream",
                "tiktokStream": "Tiktok stream",
                "traxsourceStream": "Traxsource stream",
                "youtubeStream": "Youtube stream",
                "youtubePremiumStream": "Youtube Premium stream",
                "totalSales": "Totale verkoop",
                "storeMessage": "* Winkellabels zijn alfabetisch gerangschikt (A-Z)"
            }
        },
        "salesByTerritory": {
            "title": "Verkoop Per Gebied"
        },
        "salesByGender": {
            "title": "Verkoop Per Geslacht",
            "label": {
                "male": "Man",
                "female": "Vrouw",
                "nonBinary": "Non-binair",
                "unknown": "Onbekend"
            }
        },
        "salesByAge": {
            "title": "Verkoop Per Leeftijd",
            "label": {
                "male": "Man",
                "female": "Vrouw",
                "genderOther": "Non-binair",
                "unknown": "Onbekend",
                "ageWiseSales": "Leeftijd-specifieke Verkoop",
                "ageUnknown": "Leeftijd Onbekend"
            }
        },
        "message": {
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie.",
            "subscriptionExpired": "Uw abonnement is verlopen. Gelieve uw abonnement te <1>hervatten</1> om deze functie te gebruiken.",
            "subscriptionUpgrade": "Uw huidige abonnement ondersteunt deze functie niet. Gelieve uw abonnement te <1>upgraden</1> om deze functie te gebruiken."
        }
    }
};

export default trendsNL;